<template>
    <section class="autocomplete input-group">
        <input type="text" placeholder="Пошук" v-model="query" v-on:keyup.esc="clear" v-on:keyup="autoComplete"
               class="form-control search">
        <div class="panel-footer" v-if="results.length && query.length>0">
            <ul class="list-group">
                <li class="list-group-item" v-for="result in results">
                    <a :href="'/product/'+result.id">CF-{{ result.id }} {{ result.name }}</a>
                </li>
            </ul>
        </div>
        <div v-if="!wait" class="input-group-addon"><i class="fa fa-search"></i></div>
        <div v-else class="input-group-addon"><i class="fa fa-spinner fa-spin"></i></div>

    </section>
</template>

<script>
    export default {
        name: "Autocomplete",
        data() {
            return {
                query: '',
                wait: false,
                results: []
            }
        },
        methods: {
            autoComplete() {
                if (this.timeout){
                    clearTimeout(this.timeout);
                }
                this.timeout = setTimeout(() => {
                    if (this.query.length > 0) {
                        this.results = [];
                        this.wait = true;
                        axios.get('/api/search', {params: {query: this.query}}).then(response => {
                            this.results = response.data;
                            this.wait = false;
                        });
                    }
                }, 1000);

            },
            clear() {
                this.query = '';
                this.wait = false;
                this.results = [];
            }
        }
    }
</script>

<style scoped>
    .autocomplete {
        position: relative;
    }

    .search:focus {
        box-shadow: inset 0 -1px 0 #ddd;
    }

    .panel-footer {
        position: absolute;
        background: white;
        width: 100%;
        overflow-y: auto;
        max-height: 200px;
        z-index: 1000;
        margin-top: 40px;
        box-shadow: 0px 10px 25px rgba(0, 0, 0, 0.1);
    }

    .input-group-addon {
        background-color: #0e8ce4;
        color: white;
    }
</style>
